<template>
<span>{{ gitBranch }}</span>
</template>
<script>
import { first } from 'lodash'

export default {
  props: {
    attributes: {
      type: Array,
      default: () => ([])
    }
  },

  computed: {
    gitBranch() {
      let attribute = first(this.attributes.filter(attribute => attribute.type).filter(attribute => attribute.type.title === 'Git Branch'))
      if(attribute) return attribute.value && attribute.value.length ? attribute.value : '--'
      return '--'
    }
  }
}
</script>
